import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import operateRed from './components/operateRed.vue';
import operateTop from './components/operateTop.vue';
import { mapState } from 'vuex';
import taskDialog from './components/taskDialog.vue';
export default {
  components: {
    operateTop,
    operateRed,
    taskDialog
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      showDiaglog: false
    };
  },
  computed: _objectSpread({}, mapState('url', ['isTaskOperate'])),
  methods: {
    showOpreate(value) {
      this.$emit('input', value);
    },
    closeTaskDialog() {
      this.showDiaglog = false;
    }
  },
  mounted() {
    const isShowDialog = localStorage.getItem('isShowDialog');
    // 用户每次进入只弹一次开始下滑弹窗, 后续不再弹
    if (!isShowDialog) {
      this.showDiaglog = true;
      localStorage.setItem('isShowDialog', true);
    }
  }
};